import React from 'react'
import styles from './stylesPagoTienda.module.sass'
import CurrencyFormat from "react-currency-format"

export function FormasPagoTienda(props) {

    const {
        payCard,
        barCode,
        idClaro,
        handleImprimir,
        isMobile
    } = props

    return (
        <div className='formasPagoTienda' id="no-imprimir">

            <div className={styles?.titleSection}>
                {isMobile === 'desktop'
                    ?
                        <img src="/credito-claroshop/img/newCredito/logo-claroshop.svg" alt="logoCS" width="250" height="100" />
                    : null
                }
                <p className={`${styles?.textTPTienda}`}>Pago en tienda Sears / Sanborns</p>
            </div>

            <div className={styles?.cardSection}>
                <p className={styles?.paragraph}>Paga en cualquier caja de Sears/Sanborns.</p>
                <p className={styles?.paragraph}>El pago debe ser en una sola exhibición y se verá reflejado en máximo 48 horas.</p>

                {idClaro &&
                    <img src={`${barCode}${idClaro}&draw=1`} alt="codigo-pago"></img>
                }

                <div className={styles?.montToPayment}>
                    <p>Monto a pagar</p>
                    {payCard &&
                        <CurrencyFormat
                            value={Number(payCard.totalToPay % 1) === 0 ? payCard.totalToPay + '.001' : payCard.totalToPay}
                            displayType={'text'}
                            decimalScale={2}
                            FixedDecimalScale={true}
                            thousandSeparator={true} prefix={'$'} renderText={value => <strong className={styles?.bold}>{value} </strong>}
                        />
                    }
                </div>
                
                <div className={styles?.captureScreen}>
                    <span>Captura esta pantalla y preséntala en caja</span>
                </div>

            </div>

            <div className={isMobile === "desktop" ? styles?.cajaBotonPagarTienda : ""}>
                <button className={`${styles?.btn} ${styles?.rojo}`} onClick={handleImprimir}>Descargar</button>
            </div>
        </div>
    )
}

export function PagoTiendaPrint(props) {

    const {
        payCard,
        barCode,
        idClaro
    } = props

    return (
        <div id="imprimir" className='printme'>
            <div className='formasPagoTienda' id="contenedorImprimir">
                <div className={`logoCSprint ${styles?.titleSection}`}>
                    <img src="/credito-claroshop/img/newCredito/logo-claroshop.svg" alt="logoCS" width="10cm"/>
                    <p className={`${styles?.textTPTienda}`}>Pago en tienda Sears / Sanborns</p>
                </div>

                <div className={styles?.cardSection}>
                    <p className={styles?.paragraph}>Paga en cualquier caja de Sears/Sanborns.</p>
                    <p className={styles?.paragraph}>El pago debe ser en una sola exhibición y se verá reflejado en máximo 48 horas.</p>

                   
                    {idClaro &&
                        <img src={`${barCode}${idClaro}&draw=1`} alt="codigo-pago"></img>
                    }

                    <div className={styles?.montToPayment}>
                        <p>Monto a pagar</p>
                        {payCard &&
                            <CurrencyFormat
                                value={Number(payCard.totalToPay % 1) === 0 ? payCard.totalToPay + '.001' : payCard.totalToPay}
                                displayType={'text'}
                                decimalScale={2}
                                FixedDecimalScale={true}
                                thousandSeparator={true} prefix={'$'} renderText={value => <strong className={styles?.bold}>{value} </strong>}
                            />
                        }
                    </div>

                    <div className={styles?.captureScreen}>
                        <img src="/credito-claroshop/img/icon_captura_pantalla.svg"></img>
                        <span>Captura esta pantalla y preséntala en caja</span>
                    </div>


                </div>

            </div>
        </div>
    )
}